import {Button, Form, Row, Space, Spin, Table} from "antd";
import {InputFields} from "components/common";
import React, {useEffect, useState} from "react";
import {
  columnsTable,
  dataField,
  columnsTableHH,
  columnsTableTN,
  columnsTableNT,
} from "./ParaclinicalTest.config";
import Icon from "assets/icons";
import {ExcelSVG} from "assets";
import {analysisService} from "api";
import Notification from "components/common/notification/notification";
import moment from "moment";
import {FORMAT_TIME} from "types/enums";
import dayjs from "dayjs";

const ParaclinicalTest = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [columns, setColumns] = useState(columnsTable);
  const [fields, setFields] = useState(dataField);
  const [totalPage, setTotalPage] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [form] = Form.useForm();
  const [formData, setFormData] = useState<any>();

  const handlePaginationChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
    setFormData({
      ...formData,
      page: page,
      limit: pageSize,
    });
  };

  useEffect(()=>{
    if (!formData) {
      return;
    }
    getData(formData);
  },[currentPage, pageSize])

  useEffect(() => {
    const data = form.getFieldsValue();
    if (data.loaiSoKham == null) {
      setColumns(columnsTable);
      form.resetFields();
    }
  }, []);

  useEffect(() => {
    form.setFieldValue("ngayTaoTu", dayjs());
    form.setFieldValue("ngayTaoDen", dayjs());
  }, []);

  columns.map(e => {
    if (e.key == "stt") {
      e.render = (text, record, index) => {
        const rowNumber = (currentPage - 1) * pageSize + index + 1;
        return rowNumber;
      };
    }
  });

  const getData = async data => {
    setLoading(true);
    try {
      const response = await analysisService.getBookAnalysis(data).then(res => {
        const newData = res.data.data.map(item => ({
          ...item,
          doiTuong: item.doiTuong ? item.doiTuong : "Thường",
          ngayThucHien: item.ngayThucHien
            ? moment(item.ngayThucHien).format(FORMAT_TIME.dateTime_3)
            : "",
          thoiGianIn: item.thoiGianIn
            ? moment(item.thoiGianIn).format(FORMAT_TIME.dateTime_3)
            : "",
        }));
        setData(newData);
        setTotalPage(res.data.total);
        setLoading(false);
      });
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi xảy ra khi lấy danh sách sổ xét nghiệm");
    }
  };

  const handleOnFinish = data => {
    // console.log("data", data);
    const newData = {
      ...data,
      page: currentPage,
      limit: pageSize,
      ngayTaoTu: data.ngayTaoTu
        ? dayjs(data.ngayTaoTu).format(FORMAT_TIME.dayFull)
        : null,
      ngayTaoDen: data.ngayTaoDen
        ? dayjs(data.ngayTaoDen).format(FORMAT_TIME.dayFull)
        : null,
    };
    if (newData.loaiSoKham == 0) {
      setColumns(columnsTableNT);
    }
    if (newData.loaiSoKham == 1) {
      setColumns(columnsTableHH);
    }
    if (newData.loaiSoKham == 2) {
      setColumns(columnsTableTN);
    }
    if (!newData.loaiSoKham && newData.loaiSoKham !== 0) {
      Notification("warning", "Vui lòng chọn sổ xét nghiệm cận lâm sàng");
      return;
    }
    setFormData(newData);
    // console.log('data config', newData);
    getData(newData);
  };

  const handelOnExport = async () => {
    const data = form.getFieldsValue();
    if (!data.loaiSoKham && data.loaiSoKham !== 0) {
      Notification("warning", "Vui lòng chọn sổ xét nghiệm cận lâm sàng");
      return;
    }
    const newData = {
      ...data,
      page: currentPage,
      limit: pageSize,
      ngayTaoTu: data.ngayTaoTu
        ? dayjs(data.ngayTaoTu).format(FORMAT_TIME.dayFull)
        : null,
      ngayTaoDen: data.ngayTaoDen
        ? dayjs(data.ngayTaoDen).format(FORMAT_TIME.dayFull)
        : null,
    };
    // console.log('data config export', newData);
    setLoading(true);
    try {
      const response = await analysisService
        .getDataExportBook(newData)
        .then(res => {
          // console.log("res export", res);
          var link = document.createElement("a");
          const url = window.URL.createObjectURL(res.data);
          link.href = url;
          link.download = `Báo cáo sổ xét nghiệm lâm sàng.xlsx`;
          link.click();
          Notification("success", "Đã xuất file báo cáo");
          setLoading(false);
        });
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi xảy ra khi xuất file báo cáo");
    }
  };

  const paginationConfig = {
    current: currentPage,
    total: totalPage,
    showSizeChanger: true,
    pageSize: pageSize,
    onChange: handlePaginationChange,
  };

  return (
    <Spin spinning={loading}>
      <div>
        <div className="container">
          <Form form={form} onFinish={handleOnFinish}>
            <Space direction="vertical" style={{width: "100%"}}>
              <Row gutter={[16, 16]}>
                <InputFields data={fields} />
              </Row>
              <Row justify={"end"} style={{marginTop: "16px"}}>
                <Space>
                  <Button
                    icon={<ExcelSVG />}
                    className="custom-btn"
                    onClick={handelOnExport}
                  >
                    Xuất báo cáo
                  </Button>
                  <Button
                    icon={<Icon.eye rev={0} />}
                    type="ghost"
                    className="btn-sub"
                    htmlType="submit"
                  >
                    Xem thông tin
                  </Button>
                </Space>
              </Row>
            </Space>
          </Form>
        </div>
        <div className="container">
          <Table
            bordered
            pagination={paginationConfig}
            dataSource={data}
            columns={columns}
            scroll={{x: 2500}}
          />
        </div>
      </div>
    </Spin>
  );
};

export default ParaclinicalTest;
